import axios from "axios";

export const createAnEvent = async (authtoken, { ...values }) => {
  // console.log(values);
  return await axios.post(
    `${process.env.REACT_APP_API}/event-create`,
    { values },
    {
      headers: {
        authtoken,
      },
    }
  );
};
export const editMyEvent = async (authtoken, { ...values }, eventId) => {
  // console.log(values);
  return await axios.put(
    `${process.env.REACT_APP_API}/event-edit/${eventId}`,
    { values },
    {
      headers: {
        authtoken,
      },
    }
  );
};

export const readAll = async () => {
  return await axios.get(`${process.env.REACT_APP_API}/events`);
};

export const readOne = async (eventId) => {
  return await axios.get(`${process.env.REACT_APP_API}/event/${eventId}`);
};

export const deleteOne = async (authtoken, eventId) => {
  // console.log("from helper", authtoken);
  return await axios.delete(
    `${process.env.REACT_APP_API}/event-delete/${eventId}`,

    {
      headers: {
        authtoken,
      },
    }
  );
};

export const readMyEvents = async (authtoken) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/myevents`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );
};

export const participate = async (authtoken, eventId, userId, imageUrl) => {
  // console.log(values);
  return await axios.put(
    `${process.env.REACT_APP_API}/event/participate`,
    { eventId, userId, imageUrl },
    {
      headers: {
        authtoken,
      },
    }
  );
};
